import { FIELD_VALUE_FORMAT } from '@constants'

export const mapCheckedToOuterValue = (checked: boolean, valueFormat: FIELD_VALUE_FORMAT) => {
  if (valueFormat === FIELD_VALUE_FORMAT.BOOLEAN) {
    return Boolean(checked)
  }

  return checked ? 1 : 0
}
